import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css"
import contactoI from "../../images/Content/contacto.png"
const Contactop = () => {
  return (

    <Container>

    <div className='div-form' data-aos="flip-right">
    
    <h1 className='titulo-servicio'><img className='icono-titulo' src={contactoI} />Contacto<img className='icono-titulo' src={contactoI} /></h1>

            <Col>      
<form class="formulario" action="#" method="post">
                
                <fieldset>
              <div class="floating-label-grid">
                <div class="cd-position-relative">
                  <input class="floating-label-control cd-form-control cd-width-100%" type="text" name="input-name" id="input-name" placeholder="Nombre y Apellido"/>
                  <label class="floating-label" for="input-name">Nombre y Apellido</label>
                  <svg xmlns="http://www.w3.org/2000/svg" class="cd-icon bi bi-person" viewBox="0 0 24 24" aria-hidden="true">
                    <g fill="currentColor">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
                    </g>
                  </svg>
                </div>
          
                <div class="cd-position-relative">
                  <input class="floating-label-control cd-form-control cd-width-100%" type="email" name="input-email" id="input-email" placeholder="Email" />
                  <label class="floating-label" for="input-email">Email</label>
                  <svg xmlns="http://www.w3.org/2000/svg" class="cd-icon bi bi-envelope-fill" viewBox="0 0 24 24" aria-hidden="true">
                    <g fill="currentColor">
                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
                    </g>
                  </svg>
          
          
          
                  
                </div>
          
                <div class="cd-position-relative">
                  <input class="floating-label-control cd-form-control cd-width-100%" type="tel" name="input-telefono" id="input-tel" placeholder="Telefono" />
                  <label class="floating-label" for="input-tel">Telefono</label>
          
                  <svg xmlns="http://www.w3.org/2000/svg" class="cd-icon bi bi-phone" viewBox="0 0 24 24" aria-hidden="true">
                    <g fill="currentColor">
                    <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                    </g>
                  </svg>
                </div>
          
                <div class="cd-position-relative">
                  <input class="floating-label-control cd-form-control cd-width-100%" type="text" name="input-ciudad" id="input-ciudad" placeholder="Ciudad" />
                  <label class="floating-label" for="input-ciudad">Ciudad</label>
          
                  <svg xmlns="http://www.w3.org/2000/svg" class="cd-icon bi bi-geo-alt-fill" viewBox="0 0 24 24" aria-hidden="true">
                    <g fill="currentColor">
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
                    </g>
                  </svg>
                </div>
          
          
                <div class="cd-position-relative">
                  <textarea class="floating-label-control cd-form-control cd-width-100% input" name="input-consulta" id="input-consulta" cols="30" rows="10" placeholder="¿En que podemos ayudarte?" />
                  <label class="floating-label" for="input-consulta">Consulta</label>
                </div>
          
          
              </div>
            </fieldset>
                          <button class="form-estilo btn-enviar" type="submit" name="enviar">Enviar</button>
                      </form>
                      </Col>

            </div>
            
            
    </Container>
  )
}

export default Contactop